






















import { authSym } from '@/layouts/PageLayout.vue';
import { computed, defineComponent, inject } from '@vue/composition-api';

export default defineComponent({
  components: {
    AppBarMenu: () => import('@/components/partial/AppBarMenu.vue'),
  },
  setup(props, { root: { $store } }) {
    const namaPengguna = computed(() => $store.state.pengguna.namaPengguna);
    const isLogin = computed(() => !!$store.state.pengguna.idPengguna);
    function keluar() {
      return $store.dispatch('pengguna/keluar');
    }

    const avatarUrl = computed(() => {
      const name = namaPengguna.value?.replace(' ', '+') || '';
      return `https://ui-avatars.com/api/?name=${name}&background=0D8ABC&color=fff&rounded=true&size=128`;
    });
    const auth: any = inject(authSym);

    const items = ['Keluar'];

    return {
      showAuthDialog: () => auth?.value.tampil(),
      namaPengguna,
      isLogin,
      keluar,
      avatarUrl,
      items,
    };
  },
});
